import dayjs from '../../../utils/dayjs';
import {
  buildDefaultSessionName,
  buildSessionNameFromConfig,
  getOrgIdForSessionName,
  getSessionNameConfigCache,
  getSessionPeriodRange,
  normalizeSessionNameConfig,
} from './sessionNameConfigUtils';

export { getOrgIdForSessionName };

export const generateSessionName = (userInfo, referenceDate = dayjs()) => {
  const config = getSessionNameConfigCache();
  if (config?.enabled) {
    return buildSessionNameFromConfig(config, userInfo, referenceDate);
  }
  return buildDefaultSessionName(userInfo, referenceDate);
};

export const buildCohortCreatePayload = (sessionName, config = getSessionNameConfigCache()) => {
  const { studyStartDate, studyEndDate } = getSessionPeriodRange(
    normalizeSessionNameConfig(config)
  );

  return {
    cohortName: sessionName,
    status: 'ACTIVE',
    studyStartDate,
    studyEndDate,
  };
};
